/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportDto } from '../../models/report-dto';

export interface FindNotifications$Params {
  yearMonth: string;
}

export function findNotifications(http: HttpClient, rootUrl: string, params: FindNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportDto>>> {
  const rb = new RequestBuilder(rootUrl, findNotifications.PATH, 'get');
  if (params) {
    rb.query('yearMonth', params.yearMonth, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportDto>>;
    })
  );
}

findNotifications.PATH = '/api/notifications';
